import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

// Automatically retry requests that fail with 409 Conflict (optimistic concurrency).
// The api-error interceptor (outer layer) shows the toast only after all retries fail.
export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    retry({
      count: 2,
      delay: (error: unknown, retryIndex: number) => {
        if (error instanceof HttpErrorResponse && error.status === 409) {
          // Exponential backoff: 300ms, 600ms
          return timer(300 * retryIndex);
        }
        return throwError(() => error);
      },
    }),
  );
};
